import * as dayjs from 'dayjs'

export const normalizeToTableAudience = (serverAudience) => {
  return {
    ...serverAudience,
    created_at: dayjs(serverAudience.created_at).format('DD.MM.YYYY'),
    updated_at: dayjs(serverAudience.updated_at).format('DD.MM.YYYY'),
  }
}
